import { Directory } from './Directory'
import { auth } from '../services/auth'

export function AdPortalApp() {
  if (!auth.isAuthenticated()) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white p-6 text-center dark:bg-gray-900">
        <p className="text-slate-600 dark:text-slate-300">
          This page opens from inside your LeaseCheck account. Return to your report and choose
          "Talk to an Attorney" to get here.
        </p>
      </div>
    )
  }
  const params = new URLSearchParams(window.location.search)
  const documentId = params.get('document_id')
  const viewerMode = params.get('view') // 'attorney' when an attorney is previewing their listing
  const viewerAttorneyId = params.get('me')
  return (
    <Directory
      documentId={documentId ? Number(documentId) : null}
      viewerMode={viewerMode}
      viewerAttorneyId={viewerAttorneyId ? Number(viewerAttorneyId) : null}
    />
  )
}

export default AdPortalApp
